import React from "react";
import { useLocation } from "react-router";
import { PersonAddAlt1 as AddMemberIcon } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";

import analytics from "fond/analytics";

import InviteMembersModal from "./InviteMembersModal";

type InviteMembersButtonProps = {
  variant?: ButtonProps["variant"];
  fullWidth?: ButtonProps["fullWidth"];
};
const InviteMembersButton = ({ variant = "contained", fullWidth }: InviteMembersButtonProps) => {
  const location = useLocation();
  const [isInviteMembersModalShown, setInviteMembersModalDisplay] = React.useState(false);

  const handleClick = () => {
    setInviteMembersModalDisplay(true);
    const isUserSettingsPage = location.pathname.startsWith("/settings/users");
    analytics.track("user-management.invite-members.clicked", { source: isUserSettingsPage ? "user-settings" : "sidebar" });
  };

  return (
    <>
      <Button variant={variant} fullWidth={fullWidth} startIcon={<AddMemberIcon />} onClick={handleClick} data-testid="invite-members-button">
        Invite members
      </Button>
      <InviteMembersModal isOpen={isInviteMembersModalShown} onClose={() => setInviteMembersModalDisplay(false)} />
    </>
  );
};

export default InviteMembersButton;
